<template>
  <div class="pogs-panel">
    <header>
      <h3>Users Table</h3>
    </header>

    <div class="content">

      <table>
        <tr>
          <th>Firstname</th>
          <th>Lastname</th>
          <th>Username</th>
          <th>Role</th>
        </tr>
        <tr v-for="user in users">
          <td>{{user.firstname}}</td>
          <td>{{user.lastname}}</td>
          <td>{{user.username}}</td>
          <td>{{user.role}}</td>
          <td>
            <button @click.prevent="editUser(user._id)">edit</button>
          </td>
        </tr>
      </table>
      <button @click.prevent="newUser">New User</button>

    </div>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import {ACTION_LOAD_USERS, GETTER_USERS} from '../../../store/modules/admin'

  export default {
    computed: {
      ...mapGetters({
        users: GETTER_USERS
      })
    },
    methods: {
      ...mapActions({
        loadUsers: ACTION_LOAD_USERS
      }),
      editUser(userid){
        this.$router.push({name:'EditUser', params: {userid}})
      },
      newUser(){
        this.$router.push({name:'AddUser'})
      }
    },
    mounted(){
      this.loadUsers();
    }
  }
</script>

<style lang="scss">

  @import '../../../scaffolding/scss/pogs-util';

  $cell-width  : 130px;
  $cell-height : 42px;

  %cell{
    @extend %flex-row--center-x, %border-bottom;
    padding: space(s) 0;
    min-height: $cell-height !important;

    &.disabled{
      @extend %user-no-select;
      color: color(disabled);
    }
  }

  .reports-table{
    @include make-grid-cols(280px 1fr);
    margin: space(m) 0;

    header{
      @extend %cell;
    }
  }

  .fixed-labels{
    & > header{
      @extend %border-right;
      position: relative;
      margin-top: $cell-height;

      &:after{
        content: ' ';
        height: 11px;
        width: 11px;
        position: absolute;
        top: -1px;
        right: -11px;
        background: white;
        border-top: 1px solid color(base, border);
        border-left: 1px solid color(base, border);
        border-top-left-radius: radius(normal);
        z-index: 1003;
      }

      &:before{
        z-index: 1001;
        content: ' ';
        height: 11px;
        width: 11px;
        position: absolute;
        top: -1px;
        right: -5px;
        background: white;
      }
    }

    & > section{
      @extend %border-right;

      & > header,
      .dark{
        padding-left: space(m);
      }

      & > .reports-table__cell:not(.dark) {
        padding-left: space(l);
      }
    }
  }

  .reports-table__cell{
    @extend %cell;
    min-width: $cell-width;

    &.dark{
      font-weight: font(medium-bold);
    }
  }

  .reports-table__column{
    flex: 1;

    & > header{
      justify-content: center !important;
    }

    &.left-align{
      .reports-table__cell{
        justify-content: flex-end;
        padding-right: 42%;
      }
    }

    &.right-align{
      .reports-table__cell{
        justify-content: flex-start;
        padding-left: 40%;
      }
    }

    .reports-table__cell{
      justify-content: center;
    }

    & .reports-table__cell{
      @extend %border-left;
    }

  }

  .reports-table__wrapper{
    @include make-grid-cols(1fr auto);
    @include transition(height 0.5s cubic-bezier(.17,.67,.84,.71));
  }

  .scrollable-container{
    @extend %independent-layout-container, %border-bottom;
    overflow-x: auto;
    overflow-y: hidden;
  }

  .scrollable-content{
    @extend %independent-layout, %flex;
    margin-left: -1px;
  }

  .fixed-column{
    height: 100%;
    background: color(light, light-bg);

    font-weight: font(medium-bold);

    label[dark]{
      color: color(dark);
    }

    .reports-table__cell{
      @extend %border-right;

      &:last-child{
        background: darken(color(light,light-bg), 10);
      }
    }

    header{
      position: relative;

      &:after{
        content: ' ';
        height: 11px;
        width: 11px;
        position: absolute;
        bottom: -11px;
        right: 0px;
        background: color(light, light-bg);
        border-top: 1px solid color(base, border);
        border-right: 1px solid color(base, border);
        border-top-right-radius: radius(normal);
        z-index: 1003;
      }

      &:before{
        z-index: 1001;
        content: ' ';
        height: 11px;
        width: 11px;
        position: absolute;
        bottom: -10px;
        right: 0px;
        background: color(light, light-bg);
      }
    }
  }
</style>
